import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-download-01',
  templateUrl: './download-01.html',
  styleUrl: './download-01.scss',
})
export class Download01 {
  stroke = input<string>('#797674');
  width = input<string>('1rem');
  height = input<string>('1rem');
}
